import { render, staticRenderFns } from "./MateriaPrimaView.vue?vue&type=template&id=16766a7a&scoped=true"
import script from "./MateriaPrimaView.vue?vue&type=script&lang=js"
export * from "./MateriaPrimaView.vue?vue&type=script&lang=js"
import style0 from "./MateriaPrimaView.vue?vue&type=style&index=0&id=16766a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16766a7a",
  null
  
)

export default component.exports